import { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, ZoomControl } from 'react-leaflet';
import MarkerClusterGroup from 'react-leaflet-cluster';
import 'leaflet/dist/leaflet.css';
import { useMap } from "react-leaflet";
import { MapPoint, ClusterPoint, LocationLabel, LocationColor } from '../../Interfaces/Map';
import { getIconForPoint, createClusterIcon } from './mapUtils';

const ResizeMapOnTabActive = ({ isActive }: { isActive: boolean }) => {
    const map = useMap();
    useEffect(() => {
        if (isActive) {
            requestAnimationFrame(() => {
                map.invalidateSize();
            });
        }
    }, [isActive, map]);
    return null;
};

interface MapViewProps {
    clusters: ClusterPoint[];
    isActive?: boolean;
}

export const MapView: React.FC<MapViewProps> = ({ clusters, isActive = true }) => {
    const position: [number, number] = [20.5937, 78.9629];
    const allPoints: MapPoint[] = clusters.flatMap(cluster => cluster?.points);

    return (
        <div style={{ height: '500px', width: '100%' }}>
            <MapContainer
                center={position}
                zoom={5}
                scrollWheelZoom={true}
                style={{ height: '500px', width: '100%' }}
                zoomControl={false}
            >
                <ResizeMapOnTabActive isActive={isActive} />
                <ZoomControl position="topright" />
                <TileLayer
                    url="https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}&hl=en&gl=US"
                    attribution='<a href="http://www.pococare.com">Pococare</a>'
                    subdomains={['mt0', 'mt1', 'mt2', 'mt3']}
                />

                <MarkerClusterGroup
                    iconCreateFunction={createClusterIcon}
                    maxClusterRadius={50}
                    spiderfyOnMaxZoom={true}
                    showCoverageOnHover={false}
                    zoomToBoundsOnClick={true}
                >
                    {allPoints.map((point) => {
                        const icon = getIconForPoint(point);
                        return (
                            <Marker
                                key={point.id}
                                position={[point.lat, point.lng]}
                                icon={icon}
                                // @ts-ignore
                                point={point}
                            >
                                <Popup>
                                    <div>
                                        <strong style={{ color: LocationColor[point?.type] }}>{point?.ticketId || point?.fullName}</strong>
                                        <br />
                                        <span>
                                            {LocationLabel[point?.type]}
                                        </span>
                                        <br />
                                        <span>{point.companyName}</span>
                                        <br />
                                        <span>{point.address}</span>
                                    </div>
                                </Popup>
                            </Marker>
                        );
                    })}
                </MarkerClusterGroup>
            </MapContainer>
        </div>
    );
};